import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddressService } from '../service/address/address.service';
import { basicSnackBarConfig } from '../../../utils/default-configs/configuration';
import { SnackBarService } from '../../../shared/snack-bar/services/snack-bar.service';
import { ErrorDialogService } from '../../../shared/errors/error-dialog.service';

@Component({
  selector: 'app-address-email-alert',
  templateUrl: './address-email-alert.component.html',
  styleUrls: ['./address-email-alert.component.css'],
})
export class AddressEmailAlertComponent implements OnInit {
  @Input() shipmentForm: FormGroup;
  alertPieceDataSource = new MatTableDataSource<any>();
  alertColumns: string[] = ['receiverNo', 'receiverId', 'bespokeMessage', 'Action'];
  constructor(
    private errorDialogService: ErrorDialogService,
    private snackBarService: SnackBarService,
    private addressService: AddressService,
    private _formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<AddressEmailAlertComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      openedFrom: string;
      preAlertEmails: [];
      shipmentForm: FormGroup;
      receiverAddress: any;
    }
  ) {}

  ngOnInit(): void {
    this.shipmentForm = this.data?.shipmentForm;
    if (this.data?.preAlertEmails) {
      this.patchPreAlertExisting(this.data.preAlertEmails);
    }
  }

  patchPreAlertExisting(preAlertEmailsData) {
    if (preAlertEmailsData.length > 0) {
      this.alertPieceDataSource = new MatTableDataSource(
        (this.shipmentForm.get('preAlertEmails') as FormArray).controls
      );
    }
  }

  preAlertEmails(): FormArray {
    return this.shipmentForm.get('preAlertEmails') as FormArray;
  }

  newPreAlertMsg(): FormGroup {
    return this._formBuilder.group({
      typeCode: 'email',
      receiverId: '',
      bespokeMessage: '',
    });
  }

  addPreAlert(): FormGroup {
    return this._formBuilder.group({
      typeCode: new FormControl('email'),
      receiverId: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(45)])
      ),
      bespokeMessage: new FormControl('', Validators.compose([Validators.maxLength(45)])),
    });
  }

  addMsg() {
    if (this.preAlertEmails().length <= 4) {
      const control = this.shipmentForm.get('preAlertEmails') as FormArray;
      control.insert(
        (this.shipmentForm.get('preAlertEmails') as FormArray).controls.length + 1,
        this.addPreAlert()
      );
      this.alertPieceDataSource.data = control.controls;
    }
  }

  deleteRow(index) {
    const control = this.shipmentForm.get('preAlertEmails') as FormArray;
    control.removeAt(index);
    this.alertPieceDataSource.data = control.controls;
    this.shipmentForm.markAsDirty({ onlySelf: false });
  }

  savePreAlertEmail() {
    if (this.data?.openedFrom === 'receiverShipment') {
      if (this.data?.receiverAddress?._id) {
        if (this.data?.receiverAddress.preAlertEmails) {
          this.data.receiverAddress.preAlertEmails = this.shipmentForm.value?.preAlertEmails;
          this.data.receiverAddress.shipmentNotification =
            this.data.shipmentForm.value?.shipmentNotification;
        }
        const requestBody = this.data.receiverAddress;
        this.addressService.updateAddress(requestBody).subscribe({
          next: () => {
            this.snackBarService.createSnackBar(
              basicSnackBarConfig.addressComponentUpdate?.message,
              basicSnackBarConfig.addressComponentUpdate?.horizontalPosition,
              basicSnackBarConfig.addressComponentUpdate?.verticalPosition,
              basicSnackBarConfig.addressComponentUpdate?.duration
            );
          },
          // error: err => {
          //   this.errorDialogService.openDialog(err?.error);
          // },
        });
      }
    }

    this.dialogRef.close({
      value: this.shipmentForm.value?.preAlertEmails,
      id: !!this.data?.receiverAddress?._id,
    });
  }

  disableSave() {
    if (this.data?.openedFrom === 'receiverShipment') {
      return !(
        (this.shipmentForm.get('preAlertEmails') as FormArray).valid && this.shipmentForm.dirty
      );
    } else if (this.data?.openedFrom === 'receiverAddress') {
      return !(this.shipmentForm.valid && this.shipmentForm.dirty);
    }
  }
}
